const MEDIA_TYPES = {
  image: 'image',
  video: 'video',
  document: 'document',
};

export { MEDIA_TYPES as default };



// WEBPACK FOOTER //
// ./src/components/MediaManager/MediaTypes.js